<template>
  <div>
    <base-header v-once pageName="구매 이력 조회" :popup="true"></base-header>
    
    <section id="wrap">
        <div class="purchase-list">
            <p>같은 번호로 총 <em>{{tot}}</em>건이 조회됩니다.</p>
            <ul>
                <li v-for="(buyInfo, index) in custBuyInfoList" :key="index">
                    <p>
                        <strong>{{buyInfo.kwcnam}}</strong>
                        <em><i>{{buyInfo.cntrNm}}</i><i>{{buyInfo.kwsad1}}</i></em>
                        <span class="checkbox">
                            <input type="checkbox" v-model="buyInfo.hstrYn" true-value="Y" false-value="N" :id="index" @click="updateCustPrchHstrYn(index)">
                            <label :for="index"></label>
                        </span>
                    </p>
                    <div>
                        <span v-for="(prdtnm, index2) in buyInfo.prdtnmArray" :key="index2">{{prdtnm}}</span>
                    </div>
                </li>
                <!-- 검색 결과 실패시-->
                <infinite-loading @infinite="infiniteHandler" spinner="waveDots" ref="InfiniteLoading">
                <div slot="no-more"></div>
                <div slot="no-results">
                    <div class="search-resutl-None">
                        <p>구매이력이 없습니다.</p>
                    </div> 
                </div>
                </infinite-loading>
            </ul>
        </div>
    </section> 
    <div class="btnWrap">
        <button type="button" class="red" @click="close">확인</button>
    </div>
</div>
</template>

<script>
import InfiniteLoading from "vue-infinite-loading";
export default {
  components: {
    InfiniteLoading
  },
  data() {
      return{
            searchUserid: "",
            tel1: "",
            tel2: "",
            tel3: "",
            tot:0,
            offset: 0,	 //현재 가지고있는 갯수
            size : 10,	//한번에 가져오는 수
            custBuyInfoList: [],
      };
  },
  methods: {
    infiniteHandler: function($state) {
      var that = this;
      var parameters = {
        searchUserid: this.searchUserid,
        tel1: this.tel1,
        tel2: this.tel2,
        tel3: this.tel3,
        offset: this.offset,
        size: this.size
      };
      this.$api.myCstmr.getCustBuyInfoList(parameters)
        .then(function(res) {
          that.tot = res.totCnt;
          var list = res.custBuyInfoList;
          if (list.length) {
            that.offset += that.size;
            that.custBuyInfoList = that.custBuyInfoList.concat(list);
            $state.loaded();
            if (list.length < that.size) {
              $state.complete();
            }
          } else {
            $state.complete();
          }
        })
        .catch(function(error) {
          alert(error.rtMsg);
        });
    },
    getCustBuyInfoList() { // 전화번호에 대한 구매이력조회
        this.tot = 0;
        this.offset = 0
        this.size = 10
        this.custBuyInfoList = [];
        this.$refs.InfiniteLoading.stateChanger.reset();
    },
    updateCustPrchHstrYn: function (index){ // 구매이력 등록/삭제 처리
         console.log(index);        
        //var that = this;
        var params = {
            kwkey:this.custBuyInfoList[index].kwkey
           ,cntrCd:this.custBuyInfoList[index].cntrCd
        };
        console.log("updateCustPrchHstrYn params",params);
        console.log("updateCustPrchHstrYn this.custBuyInfoList[index]",this.custBuyInfoList[index]);

      if("Y" == this.custBuyInfoList[index].hstrYn){
        this.$api.myCstmr.deleteCustPrchHstr(params)
            .then(function() {
            })
            .catch(function(error) {
                alert(error.rtMsg);
            });
      }
      else{
        this.$api.myCstmr.saveCustPrchHstr(params)
            .then(function() {
            })
            .catch(function(error) {
                alert(error.rtMsg);
            });
      }    
    },
    close: function(){
        window.app.$root.$utils.nativeIf.outbound.close(false);
    }
  },
  mounted: function() { //  인스턴스가 마운트 된 직후
    var parent = this.$store.getters.parent;
        if(parent.name == 'buy-pop-param'){  // 부모창에서 받은 정보.
            console.log("BuyInfo.vue mounted this.$store.getters.parent.data", parent.data);
            this.searchUserid = parent.data.searchUserid;
            this.tel1 = parent.data.tel1;
            this.tel2 = parent.data.tel2;
            this.tel3 = parent.data.tel3;
            
            // 넘어온 파라메터 초기화
            parent = {
                name: 'buy-pop-param',
                data: {
                  searchUserid:""
                  ,tel1:""
                  ,tel2:""
                  ,tel3:""
                }
            };
            this.$store.commit("SET_UI_PARENT", parent);


            this.getCustBuyInfoList();
        }
  }
}
</script>
